import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 2000 }

import { Input, Select, Option, Button, ButtonGroup, Form, FormItem, Dropdown, DropdownMenu, DropdownItem, Table, Loading, TableColumn, Pagination, Dialog, Popover } from 'element-ui'

var elementuis = [
    Input,
    Select,
    Option,
    Button,
    ButtonGroup,
    Form,
    FormItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Table,
    Loading,
    TableColumn,
    Pagination,
    Dialog,
    Popover,
]

elementuis.forEach(element => {
    Vue.use(element)
})
